import React, { useEffect } from 'react';
import styled from 'styled-components';
import UniversalIconBtn from '../../../shared/component/headless/button/UniversalIconBtn';
import { BlackFullWidthBtn } from '../../../shared/component/headless/button/BtnBody';
import HeadlessBtn from '../../../shared/component/headless/button/HeadlessBtn';

import belowIcon from '../../../asset/icon/below.png';
import { getBtnName } from '../../../shared/constants/btnNames';
import { getModalMessage } from '../../../shared/constants/modalMessages';
import { getPageMessage } from '../../../shared/constants/pageMessages';
import { useProjectDetailState } from '../../../shared/hooks/useApi/useProjectDetail';
import { useCanShowProjectDetail } from '../../../shared/hooks/useProjectVisibility';
import { useImportStationWorkStore } from '../../../shared/store/importStationWorkStore';
import { useModalStore } from '../../../shared/store/portal/modalStore';
import { useModalWorkTagStore } from '../../../shared/store/workTagStore';

import ImportTagStation from '../ImportTagStation';
import PageAboutWorkImport from '../PageAboutWorkImport';
import SimpleWorkForFormationItem from '../SimpleWorkForFormationItem';
import FormationImportSelectionSlots from '../FormationImportSelectionSlots';
import { clearFormationSlotImportModalState } from '../useFormationSlotImport';
import { useFormationSlotImport } from '../useFormationSlotImport';

const ImportStationForFormationSlotMobile: React.FC = () => {
  const { clearModal } = useModalStore();
  const { project } = useProjectDetailState();
  const canShowProject = useCanShowProjectDetail();
  const { simpleList } = useImportStationWorkStore();
  const { selectedModalTags } = useModalWorkTagStore();
  const {
    availableSlotIndexes,
    formationItems,
    formationType,
    importToEmptySlots,
    isBulkImport,
    selectedDataList,
  } = useFormationSlotImport();

  useEffect(() => () => {
    clearFormationSlotImportModalState();
  }, []);

  const handleClose = () => {
    clearFormationSlotImportModalState();
    clearModal(400);
  };

  if (!canShowProject || !project) return null;

  return (
    <ImportComp>
      <TitleWrapper>
        <TitleContainer>
          <Title>
            {getModalMessage('SELECT_TO_IMPORT_WORK_DETAIL')}
            {isBulkImport && availableSlotIndexes.length > 0
              && ` (${selectedDataList.length}/${availableSlotIndexes.length})`}
          </Title>
        </TitleContainer>
        <UniversalIconBtn
          size="fit"
          border={false}
          isTransparent={true}
          backgroundImg={belowIcon}
          onClick={handleClose}
          aria-label="Close"
        />
      </TitleWrapper>
      {isBulkImport && formationType && (
        <FormationImportSelectionSlots
          formationItems={formationItems}
          formationType={formationType}
        />
      )}
      <ImportTagStation />
      <ContentContainer>
        {simpleList.length === 0 ? (
          <NoContentContainer>
            {selectedModalTags.length > 0
              ? getPageMessage('IMPORT_STATION_NO_WORK_FOR_SELECTED_TAGS')
              : getPageMessage('IMPORT_STATION_EMPTY_WORK')}
          </NoContentContainer>
        ) : (
          simpleList.map((sw) => (
            <SimpleWorkForFormationItem key={sw.id} data={sw} />
          ))
        )}
      </ContentContainer>
      <PageAboutWorkImport />
      {isBulkImport && availableSlotIndexes.length > 0 && (
        <HeadlessBtn
          value={getBtnName('IMPORT')}
          handleClick={importToEmptySlots}
          StyledBtn={SubmitButton}
        />
      )}
    </ImportComp>
  );
};

const ImportComp = styled.div`
  width: 100%;
  height: 80vh;
  min-height: 80vh;
  display: flex;
  flex-direction: column;
`;

const TitleWrapper = styled.div`
  position: relative;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 10px;
  color: ${({ theme }) => theme.colors.color_Gray_02};
  margin-top: clamp(12px, 2vh, 30px);
  margin-bottom: clamp(20px, 8vh, 30px);
`;

const TitleContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
  color: ${({ theme }) => theme.colors.color_Gray_01};
`;

const Title = styled.div`
  ${({ theme }) => theme.typography.Body_01_1};
  color: ${({ theme }) => theme.colors.color_Gray_02};
`;


const ContentContainer = styled.div`
  flex: 1;
  min-height: 0;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  overflow-y: auto;
  &::-webkit-scrollbar {
    display: none;
  }
`;

const NoContentContainer = styled.div`
  width: 100%;
  flex: 1;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  color: ${({ theme }) => theme.colors.color_Gray_04};
  ${({ theme }) => theme.typography.Body_03_2};
  white-space: pre-line;
`;

const SubmitButton = styled(BlackFullWidthBtn)`
  margin: 12px 0 8px;
`;

export default ImportStationForFormationSlotMobile;
